import React from "react"
import { FaSearch } from "react-icons/fa";

export const Searcher = () => {

    const [search,setSearch] = React.useState('');

    return (
        <div className="searcher-component">
          <div className="searching">
                <input 
                        name=""
                        placeholder="Search"
                        value={search}
                        onChange={e=>{
                            setSearch(e.target.value)
                        }}
                    />
                    <FaSearch />
            </div>
        </div>
    )

}
 
